module.exports = __webpack_public_path__ + "img/ax-desktop-hover.118644d6.png";